import { render, staticRenderFns } from "./WXNews.vue?vue&type=template&id=9d80a590"
import script from "./WXNews.vue?vue&type=script&lang=js"
export * from "./WXNews.vue?vue&type=script&lang=js"
import style0 from "./WXNews.vue?vue&type=style&index=0&id=9d80a590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports